import { useState, useEffect } from 'react';

const TopCategories2 = () => {
  const [categories] = useState([
    {
      id: 1,
      icon: '/IROKO_IMAGE/design_num.jpeg',
      title: 'Design numérique (CAD, VR, Game Dev, 3D Printing)',
      courses: 573,
    },
    {
      id: 2,
      icon: '/IROKO_IMAGE/fab_dig.jpeg',
      title: 'Fabrication digitale (CNC, Laser, Moulage, Matériaux)',
      courses: 565,
    },
    {
      id: 3,
      icon: '/IROKO_IMAGE/electro_robot.jpeg',
      title: 'Électronique & Robotique (Arduino, AI, Automatisation, IoT)',
      courses: 126,
    },
    {
      id: 4,
      icon: '/IROKO_IMAGE/prog.jpeg',
      title: 'Programmation embarquée & logiciels',
      courses: 35,
    },
    {
      id: 5,
      icon: '/IROKO_IMAGE/inov_entr.jpeg',
      title: 'Innovation & Entrepreneuriat',
      courses: 908,
    },
    {
      id: 6,
      icon: '/IROKO_IMAGE/design_num.jpeg',
      title: 'Design numérique (CAD, VR, Game Dev, 3D Printing)',
      courses: 573,
    },
    {
      id: 7,
      icon: '/IROKO_IMAGE/fab_dig.jpeg',
      title: 'Fabrication digitale (CNC, Laser, Moulage, Matériaux)',
      courses: 565,
    },
    {
      id: 8,
      icon: '/IROKO_IMAGE/electro_robot.jpeg',
      title: 'Électronique & Robotique (Arduino, AI, Automatisation, IoT)',
      courses: 126,
    },
    {
      id: 9,
      icon: '/IROKO_IMAGE/prog.jpeg',
      title: 'Programmation embarquée & logiciels',
      courses: 35,
    },
    {
      id: 10,
      icon: '/IROKO_IMAGE/inov_entr.jpeg',
      title: 'Innovation & Entrepreneuriat',
      courses: 908,
    }
  ]);

  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesPerView, setSlidesPerView] = useState(6);
  const [containerStyle, setContainerStyle] = useState({});

  // Gestion de la responsivité améliorée
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width < 480) {
        setSlidesPerView(1.5); // 1.5 élément (1 complet + moitié du suivant)
        setContainerStyle({ paddingLeft: '1rem', paddingRight: '1rem' });
      } else if (width < 640) {
        setSlidesPerView(1.8); // 1.8 élément (1 complet + partie du suivant)
        setContainerStyle({ paddingLeft: '1.5rem', paddingRight: '1.5rem' });
      } else if (width < 768) {
        setSlidesPerView(2.2); // 2.2 éléments
        setContainerStyle({ paddingLeft: '1.5rem', paddingRight: '1.5rem' });
      } else if (width < 1024) {
        setSlidesPerView(3); // 3 éléments sur tablettes paysage
        setContainerStyle({});
      } else if (width < 1280) {
        setSlidesPerView(4); // 4 éléments sur petits écrans desktop
        setContainerStyle({});
      } else if (width < 1536) {
        setSlidesPerView(5); // 5 éléments sur écrans moyens
        setContainerStyle({});
      } else {
        setSlidesPerView(6); // 6 éléments sur grands écrans
        setContainerStyle({});
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const totalSlides = Math.ceil(categories.length / Math.floor(slidesPerView));

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === totalSlides - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-white dark:bg-dark-1 transition-colors duration-300">
      <div className="mx-auto px-4 sm:px-6 md:px-12 lg:px-16 xl:px-20 2xl:px-28">
        <div className="flex justify-center text-center mb-8 md:mb-12">
          <div className="max-w-2xl px-4">
            <h2 className="text-2xl sm:text-3xl md:text-title font-bold text-dark-1 dark:text-white mb-3 md:mb-4">
              Nos Disciplines
            </h2>
            <p className="text-subtitle sm:text-base text-gray-600 dark:text-gray-300">
              Explore les fondamentaux pour innover et créer
            </p>
          </div>
        </div>

        <div className="relative overflow-hidden" style={containerStyle}>
          <div className="flex transition-transform duration-300 ease-in-out"
            style={{ transform: `translateX(-${currentSlide * (100 / slidesPerView)}%)` }}>
            {categories.map((category) => (
              <div
                key={category.id}
                className="flex-shrink-0 px-2 sm:px-3 md:px-4 lg:px-5"
                style={{ width: `${100 / slidesPerView}%` }}
              >
                <div className="group bg-light-3 dark:bg-dark-2 rounded-xl p-4 sm:p-5 md:p-6 transition-all duration-300
                hover:bg-dark-1 cursor-pointer dark:hover:shadow-xl dark:hover:-translate-y-3">
                  <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 flex items-center justify-center rounded-full  dark:bg-dark-1
                    mb-3 md:mb-4 transition-colors">
                      <img
                        src={category.icon}
                        alt={category.title}
                        className="rounded-full"
                      />
                    </div>
                    <h3 className="text-normal text-dark-1 group-hover:text-white dark:text-white mb-2 leading-tight">
                      {category.title}
                    </h3>
                    <p className="text-normal text-gray-600 dark:text-gray-300 group-hover:text-white">
                      {category.courses}+ <br /> Courses
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contrôles de navigation */}
        <div className="flex justify-center items-center mt-8 md:mt-12 space-x-4">
          <button
            onClick={prevSlide}
            className="p-2 rounded-full text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors
            touch-manipulation active:scale-95"
            aria-label="Previous slide"
          >
            <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <div className="flex space-x-2 overflow-x-auto max-w-xs sm:max-w-none">
            {Array.from({ length: totalSlides }).map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-2 h-2 sm:w-2.5 sm:h-2.5 rounded-full flex-shrink-0 transition-colors touch-manipulation ${index === currentSlide
                    ? 'bg-blue-600 dark:bg-blue-500'
                    : 'bg-gray-300 dark:bg-gray-600'
                  }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>

          <button
            onClick={nextSlide}
            className="p-2 rounded-full text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors
            touch-manipulation active:scale-95"
            aria-label="Next slide"
          >
            <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default TopCategories2;